import request from './utils/request';
import {createAction} from "redux-actions";
import {urls} from "../constants/app";
import {setError} from "./errors";

export const setProductCategories = createAction(
    'SET_PRODUCT_CATEGORIES',
    (items, type) => ({items, type})
);

export const setProductCategoriesCount = createAction('SET_PRODUCT_CATEGORIES_COUNT');
export const addProductCategorySuccess = createAction('ADD_PRODUCT_CATEGORY_SUCCESS');
export const deleteProductCategorySuccess = createAction('DELETE_PRODUCT_CATEGORY_SUCCESS');
export const updateProductCategorySuccess = createAction('UPDATE_PRODUCT_CATEGORY_SUCCESS');

export const fetchProductCategories = (type) => async (dispatch) => {
    try {
        dispatch({type: 'SET_CATEGORIES_LOADER', payload: true});
        const response = await request({
            method: 'get',
            url: urls.productscategories,
            params: {'type': type}
        });

        const items = response.data.data ?
            response.data.data.map(item => ({
                id: item.id,
                ...item.attributes
            })) : response.data;

        dispatch(setProductCategories(items, type));
        dispatch(setProductCategoriesCount(items.length));
    } catch (error) {
        dispatch({type: 'SET_CATEGORIES_ERROR', payload: error.message});
    } finally {
        dispatch({type: 'SET_CATEGORIES_LOADER', payload: false});
    }
};
export const createProductCategory = (categoryData, type) => async (dispatch) => {
    try {
        dispatch({ type: 'SET_CATEGORIES_LOADER', payload: true });

        const response = await request({
            method: 'post',
            url: urls.productscategories,
            data: categoryData,
        });

        dispatch(addProductCategorySuccess({ ...response.data, type }));
        return true;
    } catch (error) {
        dispatch(setError(error, "modalCategory"));
    } finally {
        dispatch({ type: 'SET_CATEGORIES_LOADER', payload: false });
    }
};

export const updateProductCategory = (id, categoryData, type) => async (dispatch) => {
    try {
        dispatch({ type: 'SET_CATEGORIES_LOADER', payload: true });

        const response = await request({
            method: 'put',
            url: `${urls.productscategories}/${id}`,
            data: categoryData,
        });

        dispatch(updateProductCategorySuccess({ ...response.data, type }));
        return true;
    } catch (error) {
        dispatch(setError(error, "modalCategory"));
    } finally {
        dispatch({ type: 'SET_CATEGORIES_LOADER', payload: false });
    }
};


export const deleteProductCategory = (id, type) => async (dispatch) => {
    try {
        dispatch({ type: 'SET_CATEGORIES_LOADER', payload: true });
        await request({
            method: 'delete',
            url: `${urls.productscategories}/${id}`
        });

        dispatch(deleteProductCategorySuccess({ id, type }));
        return true;
    } catch (error) {
        dispatch(setError(error, "modalCategory"));
    } finally {
        dispatch({ type: 'SET_CATEGORIES_LOADER', payload: false });
    }
};
